// Must load before the app entry — Solana libs use the Buffer global at module init time.
import { Buffer } from 'buffer';

(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;
